/**
 * Product Reload - единый модуль для обновления продуктов, фильтров и счетчиков
 */

// ==================== Счетчик товаров ====================

/**
 * Обновляет счетчик товаров на странице
 */
window.updateProductsCount = function() {
  const countElements = document.querySelectorAll('.products-count-number');
  if (countElements.length === 0) return;
  
  // Проверяем, находимся ли мы на странице поиска
  const isSearchPage = window.location.pathname.includes('/search');
  
  // Проверяем, есть ли данные о количестве результатов поиска
  const resultsList = /** @type {HTMLElement} */ (document.querySelector('results-list'));
  let totalCount = 0;
  
  if (isSearchPage && resultsList) {
    // На странице поиска используем точное количество результатов
    const searchResultsCountAttr = resultsList.getAttribute('data-search-results-count');
    if (searchResultsCountAttr) {
      const searchResultsCount = parseInt(searchResultsCountAttr);
      if (!isNaN(searchResultsCount) && searchResultsCount > 0) {
        totalCount = searchResultsCount;
      }
    }
  }
  
  // Всегда считаем видимые карточки из DOM для fallback
  const gridItems = document.querySelectorAll('.product-grid__item');
  const visibleCount = Array.from(gridItems).filter(item => {
    const htmlItem = /** @type {HTMLElement} */ (item);
    const style = window.getComputedStyle(htmlItem);
    return style.display !== 'none' && style.visibility !== 'hidden' && htmlItem.offsetParent !== null;
  }).length;
  
  // Если не на странице поиска или не получили данные, используем видимые карточки
  if (totalCount === 0) {
    totalCount = visibleCount;
  }
  
  // Пытаемся получить данные из пагинации для более точного подсчета
  const paginationDiv = /** @type {HTMLElement} */ (document.querySelector('.paginShop'));
  
  // Используем пагинацию только если не на странице поиска
  if (paginationDiv && paginationDiv.dataset && !isSearchPage) {
    // Читаем data-атрибуты (они в kebab-case, но dataset автоматически конвертирует в camelCase)
    const totalItems = parseInt(paginationDiv.dataset.paginationItems || '0');
    const cardsOnPage = parseInt(paginationDiv.dataset.paginationCards || '0');
    const itemsPerPage = parseInt(paginationDiv.dataset.paginationPageSize || '0');
    
    // Если есть точные данные - используем их
    if (!isNaN(totalItems) && totalItems > 0 && !isNaN(cardsOnPage) && cardsOnPage > 0 && !isNaN(itemsPerPage) && itemsPerPage > 0) {
      const avgCardsPerProduct = cardsOnPage / itemsPerPage;
      totalCount = Math.round(totalItems * avgCardsPerProduct);
    } else if (!isNaN(totalItems) && totalItems > 0 && visibleCount > 0) {
      // Если есть только totalItems - оцениваем через текущие карточки
      const estimatedCardsPerProduct = visibleCount / Math.max(itemsPerPage || 20, 1);
      totalCount = Math.round(totalItems * estimatedCardsPerProduct);
    } else {
      // Если данных пагинации нет, используем видимые карточки
      totalCount = visibleCount;
    }
    
    // Обновляем информацию о странице
    const currentPage = parseInt(paginationDiv.dataset.paginationCurrent || '1');
    const totalPages = parseInt(paginationDiv.dataset.paginationTotal || '1');
    
    if (totalPages > 1) {
      const paginationCurrentElements = document.querySelectorAll('.pagination-current');
      const paginationTotalElements = document.querySelectorAll('.pagination-total');
      
      paginationCurrentElements.forEach(el => {
        el.textContent = String(currentPage);
      });
      
      paginationTotalElements.forEach(el => {
        el.textContent = String(totalPages);
      });
      
      // Показываем информацию о странице, если она скрыта
      const paginationInfoElements = document.querySelectorAll('.pagination-info');
      paginationInfoElements.forEach(el => {
        const htmlEl = /** @type {HTMLElement} */ (el);
        htmlEl.style.display = '';
      });
    } else {
      // Скрываем информацию о странице, если страница одна
      const paginationInfoElements = document.querySelectorAll('.pagination-info');
      paginationInfoElements.forEach(el => {
        const htmlEl = /** @type {HTMLElement} */ (el);
        htmlEl.style.display = 'none';
      });
    }
  } else {
    // Если нет блока пагинации, используем видимые карточки
    totalCount = visibleCount;
    
    // Скрываем информацию о странице, если нет данных пагинации
    const paginationInfoElements = document.querySelectorAll('.pagination-info');
    paginationInfoElements.forEach(el => {
      const htmlEl = /** @type {HTMLElement} */ (el);
      htmlEl.style.display = 'none';
    });
  }
  
  // Обновляем все счетчики
  countElements.forEach(element => {
    element.textContent = String(totalCount || 0);
  });
};

// Дебаунс для обновления счетчика
let updateTimeout = null;
function debouncedUpdate(delay = 150) {
  if (updateTimeout) clearTimeout(updateTimeout);
  updateTimeout = setTimeout(() => {
    window.updateProductsCount();
  }, delay);
}

// Инициализация счетчика
function initProductsCounter() {
  // Обновление при загрузке страницы
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(window.updateProductsCount, 200);
      // Дополнительное обновление для страницы поиска
      setTimeout(window.updateProductsCount, 500);
    });
  } else {
    setTimeout(window.updateProductsCount, 200);
    // Дополнительное обновление для страницы поиска
    setTimeout(window.updateProductsCount, 500);
  }
  
  // Обновление после AJAX-рендеринга
  document.addEventListener('shopify:section:load', () => {
    // Небольшая задержка для гарантии, что DOM обновлен
    debouncedUpdate(200);
    // Дополнительное обновление для страницы поиска
    setTimeout(window.updateProductsCount, 500);
  });
  
  document.addEventListener('filter:update', () => {
    debouncedUpdate(200);
  });
  
  // Обновление после view transition
  document.addEventListener('view-transition-end', () => {
    debouncedUpdate(100);
  });
  
  // Также отслеживаем изменения в DOM через MutationObserver
  const resultsList = document.querySelector('results-list');
  if (resultsList) {
    const observer = new MutationObserver((mutations) => {
      // Проверяем, что изменения касаются product-grid или data-атрибутов
      const hasRelevantChanges = mutations.some(mutation => {
        const target = /** @type {HTMLElement} */ (mutation.target);
        return (target.classList && target.classList.contains('product-grid')) || 
               (target.classList && target.classList.contains('product-grid__item')) ||
               (target.querySelector && target.querySelector('.product-grid__item')) ||
               (mutation.type === 'attributes' && mutation.attributeName === 'data-search-results-count');
      });
      
      if (hasRelevantChanges) {
        debouncedUpdate(150);
      }
    });
    observer.observe(resultsList, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-search-results-count']
    });
  }
}

// ==================== Обработка фильтров ====================

/**
 * Устанавливает правильное состояние фильтров при открытии drawer
 */
function setDefaultFilterState() {
  const drawer = document.getElementById('filters-drawer');
  if (!drawer) return;
  
  const dialog = drawer.querySelector('dialog');
  if (!dialog || !dialog.open) return;
  
  // Проверяем, что мы на мобильном
  const isMobile = window.innerWidth < 750;
  if (!isMobile) return;
  
  // Получаем все accordion-custom элементы в drawer
  const allAccordions = drawer.querySelectorAll('accordion-custom');
  const allDetails = drawer.querySelectorAll('details');
  
  // Сначала сворачиваем все
  allDetails.forEach(details => {
    details.removeAttribute('open');
  });
  allAccordions.forEach(accordion => {
    accordion.removeAttribute('open');
  });
  
  // Затем открываем только те, которые должны быть открыты по умолчанию
  allAccordions.forEach(accordion => {
    if (accordion.hasAttribute('open-by-default-on-mobile')) {
      const details = accordion.querySelector('details');
      if (details) {
        details.setAttribute('open', '');
        accordion.setAttribute('open', '');
      }
    }
  });
}

/**
 * Разворачивает нужный фильтр при открытии drawer через кнопку
 */
function initFilterButtons() {
  // Обработчик открытия drawer - устанавливаем правильное состояние фильтров
  document.addEventListener('dialog:open', (e) => {
    const customEvent = /** @type {CustomEvent} */ (e);
    const target = /** @type {HTMLElement} */ (customEvent.target);
    if (target && target.id === 'filters-drawer') {
      // Задержка для гарантии, что drawer полностью открыт и все accordion-custom элементы подключены
      setTimeout(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setDefaultFilterState();
          });
        });
      }, 100);
    }
  });
  
  // Функция для разворачивания фильтра по ID
  function expandFilterById(filterId) {
    const drawer = document.getElementById('filters-drawer');
    if (!drawer) return;
    
    const dialog = drawer.querySelector('dialog');
    if (!dialog || !dialog.open) return;
    
    // Получаем данные из кнопки
    const button = /** @type {HTMLElement} */ (document.querySelector(`[data-filter-id="${filterId}"]`));
    if (!button) return;
    
    const filterLabel = button.dataset?.filterLabel;
    const searchParam = button.dataset?.filterParam;
    
    let filterDetails = null;
    
    // 1. Пробуем найти по ID
    try {
      filterDetails = drawer.querySelector(`#${filterId}`);
    } catch (e) {
      // Игнорируем ошибки с ID
    }
    
    // 2. Если не нашли, ищем по label (самый надежный способ)
    if (!filterDetails && filterLabel) {
      const allLabels = drawer.querySelectorAll('.facets__label');
      for (const label of allLabels) {
        if (label.textContent?.trim() === filterLabel.trim()) {
          // Нашли label, ищем родительский details
          filterDetails = label.closest('details');
          break;
        }
      }
    }
    
    // 3. Если все еще не нашли, пробуем по param
    if (!filterDetails && searchParam) {
      const accordion = drawer.querySelector(`accordion-custom[data-filter-param-name="${searchParam}"]`);
      if (accordion) {
        filterDetails = accordion.querySelector('details');
      }
    }
    
    if (!filterDetails) return;
    
    // Сначала находим родительский accordion
    const parentAccordion = filterDetails.closest('accordion-custom');
    
    // Сворачиваем все фильтры одним проходом
    const allDetails = drawer.querySelectorAll('details');
    const allAccordions = drawer.querySelectorAll('accordion-custom');
    
    // Сворачиваем все details, кроме нужного
    for (const details of allDetails) {
      if (details !== filterDetails) {
        details.removeAttribute('open');
      }
    }
    
    // Сворачиваем все accordion-custom, кроме родительского
    for (const accordion of allAccordions) {
      if (accordion !== parentAccordion) {
        accordion.removeAttribute('open');
      }
    }
    
    // Разворачиваем нужный details
    filterDetails.setAttribute('open', '');
    
    // Разворачиваем родительский accordion, если есть
    if (parentAccordion) {
      parentAccordion.setAttribute('open', '');
    }
    
    // Скроллим к нему
    const targetElement = parentAccordion || filterDetails;
    targetElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  
  // Обработчик клика на кнопку фильтра
  document.addEventListener('click', (event) => {
    const target = /** @type {HTMLElement} */ (event.target);
    const button = target?.closest('.facets__filter-button');
    if (!button) return;
    
    const filterId = button.dataset?.filterId;
    if (!filterId) return;
    
    // Ждем открытия drawer и разворачиваем фильтр
    const handleDialogOpen = () => {
      // Небольшая задержка для гарантии, что drawer полностью открыт
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          // Сначала устанавливаем правильное состояние (сворачиваем все)
          setDefaultFilterState();
          // Затем разворачиваем нужный фильтр
          setTimeout(() => {
            expandFilterById(filterId);
          }, 50);
        });
      });
    };
    
    // Если drawer уже открыт, разворачиваем сразу
    const drawer = document.getElementById('filters-drawer');
    const dialog = drawer?.querySelector('dialog');
    
    if (dialog?.open) {
      handleDialogOpen();
    } else {
      // Иначе ждем события открытия
      const onceHandler = (e) => {
        const customEvent = /** @type {CustomEvent} */ (e);
        const target = /** @type {HTMLElement} */ (customEvent.target);
        if (target && target.id === 'filters-drawer') {
          handleDialogOpen();
        }
      };
      document.addEventListener('dialog:open', onceHandler, { once: true });
    }
  });
}

// Инициализация при загрузке
initProductsCounter();
initFilterButtons();

